export const toTitleCase = (s = "") =>
  s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const formatCity = (city) => {
  if (!city) return "N/A";
  return city
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatDateFromUnix = (seconds, variant = "full") => {
  if (!seconds) return "N/A";
  const date = new Date(seconds * 1000);
  if (isNaN(date.getTime())) return "N/A";
  const opts =
    variant === "short"
      ? { month: "short", day: "numeric" }
      : { month: "short", day: "numeric", year: "numeric" };
  return new Intl.DateTimeFormat("en-US", opts).format(date);
};

export const formatDateFromISO = (isoDate, variant = "full") => {
  if (!isoDate) return "N/A";
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return "N/A";
  const opts =
    variant === "short"
      ? { month: "short", day: "numeric" }
      : { month: "short", day: "numeric", year: "numeric" };
  return new Intl.DateTimeFormat("en-US", opts).format(date);
};
